import { ChipProps, styled } from '@mui/material';
import StyChip from 'routes/HumanResourcesModule/components/ui/StyChip';

const StyIconChip = styled(StyChip, {
    shouldForwardProp: (prop) => prop !== 'styledColor',
    name: 'StyChip',
})(({ styledColor }: ChipProps & { styledColor: string }) => ({
    '&&& .MuiChip-label': {
        color: styledColor,
        fontSize: '11px',
        paddingLeft: 0,
    },
}));

export default StyIconChip;
